import React from 'react';
import { Loader2, AlertCircle, CheckCircle, KeyRound } from 'lucide-react';
import type { ResetStatus } from './types';

export const getStatusIcon = (status: ResetStatus): React.ReactNode => {
  const iconClasses = 'w-10 h-10 text-white';
  switch (status) {
    case 'validating':
    case 'submitting':
      return <Loader2 className={`${iconClasses} animate-spin`} />;
    case 'ready':
      return <KeyRound className={iconClasses} />;
    case 'success':
      return <CheckCircle className={iconClasses} />;
    case 'error':
      return <AlertCircle className={iconClasses} />;
    case 'expired':
      return <AlertCircle className={iconClasses} />;
  }
};

export const getIconBackground = (status: ResetStatus): string => {
  switch (status) {
    case 'validating':
    case 'submitting':
    case 'ready':
      return 'var(--color-accent-teal)';
    case 'success':
      return 'var(--color-accent-green)';
    case 'error':
    case 'expired':
      return 'var(--color-error, #ef4444)';
  }
};

export const getTitle = (status: ResetStatus): string => {
  switch (status) {
    case 'validating':
      return 'Validating link...';
    case 'ready':
      return 'Reset your password';
    case 'submitting':
      return 'Resetting password...';
    case 'success':
      return 'Password reset!';
    case 'error':
      return 'Reset failed';
    case 'expired':
      return 'Link expired';
  }
};

export const getSubtitle = (status: ResetStatus, errorMessage: string): string => {
  switch (status) {
    case 'validating':
      return 'Please wait while we verify your reset link.';
    case 'ready':
      return 'Enter your new password below.';
    case 'submitting':
      return 'Please wait while we update your password.';
    case 'success':
      return "Your password has been reset and you're being signed in.";
    case 'error':
    case 'expired':
      return errorMessage;
  }
};
